import moment from 'moment-timezone';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';

export const BuyerPropertyAppointmentModal = ({
  showModal,
  startDate,
  propertyTimes,
  handleTimeChange,
  selectedProperties,
  propertiesChecked,
  setStartDate,
  appointmentError,
  setAppointmentError,
  disabled,
  postAppointment,
  setShowModal,
}) => {
  return (
    <>
      <Modal show={showModal} backdrop="static" centered dialogClassName="property-modal">
        <Modal.Header
          closeButton
          onClick={() => {
            setAppointmentError(null);
            setShowModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>New Property Appointment</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2 mt-2">
            Appointment Date:
          </label>
          <ReactDatePicker 
            selected={startDate} 
            onChange={(date) => setStartDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Date"
            customInput={
              <input
                autoComplete="off"
                className={`form-control d-block w-100 mb-2`}
                type="text"
              />} 
          />
          {selectedProperties.length === 0 && (
            <p>No properties selected.</p>
          )}
          {selectedProperties.map(propertyId => {
            const property = propertiesChecked.find(p => p.id == propertyId);
            return (
              <div key={propertyId}>
                <label className="form-label mb-2 mt-2">
                  Property Ref: {property?.propertyRef}
                </label>
                <ReactDatePicker 
                  selected={propertyTimes[propertyId]?.startTime || null} 
                  onChange={(time) => handleTimeChange(propertyId, 'startTime', time)}
                  dateFormat="HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  placeholderText="Start Time"
                  customInput={
                    <input
                      autoComplete="off"
                      className={`form-control d-block w-100 mb-2`}
                      type="text"
                    />} 
                />
                <ReactDatePicker 
                  selected={propertyTimes[propertyId]?.endTime || null} 
                  onChange={(time) => handleTimeChange(propertyId, 'endTime', time)}
                  dateFormat="HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  placeholderText="End Time"
                  customInput={
                    <input
                      autoComplete="off"
                      className={`form-control d-block w-100 mb-2`}
                      type="text"
                    />} 
                />
              </div>
            );
          })}
          {appointmentError && (
            <small className="text-danger">{appointmentError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="property-primary-btn"
            onClick={(event) => postAppointment(event)}
            disabled={startDate !== null && disabled === true}
          >
            {startDate !== null && disabled === true
              ? 'Saving...'
              : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
